<script>
  import solicitacaoBolsaServico from '../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import tiposConta from '~js/tipos-conta';
  import tiposPix from '~js/tipos-pix';
  import tiposQuadro from '~js/tipos-quadro';
  import tiposQuadroUSP from '~js/tipos-quadro-usp';
  import regimesTrabalhoUSP from '~js/regime-trabalho-usp';
    import Barcode from '@xkeshi/vue-barcode';

  export default {
    components: { Cabecalho, Barcode },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        tiposConta: tiposConta,
        tiposPix: tiposPix,
        configuracao: this.$storage.configuracao(),
        tiposQuadro: tiposQuadro,
        tiposQuadroUSP: tiposQuadroUSP,
        regimesTrabalhoUSP: regimesTrabalhoUSP,
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoBolsaServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          });
      },
      tipoConta(id) {
        return this.tiposConta.find(t => {
          return t.id === id;
        });
      },
      tipoBolsa(tipo) {
        if (tipo === 1) {
          return 'Bolsa';
        } else if (tipo === 2) {
          return 'RPA';
        } else if (tipo === 3) {
          return 'Estágio';
        } else if (tipo === 4) {
          return 'Termo aditivo';
        } else if (tipo === 5) {
          return 'Adicional variável';
        } else {
          return '';
        }
      },
      tipoQuadro(id) {
        return this.tiposQuadro.find(t => {
          return t.id === id;
        });
      },
      tipoQuadroUSP(id) {
        return this.tiposQuadroUSP.find(t => {
          return t.id === id;
        });
      },
      regimeTrabalhoUSP(id) {
        return this.regimesTrabalhoUSP.find(t => {
          return t.id === id;
        });
      },
      tipoPix(id) {
        return this.tiposPix.find(t => {
          return t.id === id;
        });
      },
      classeOpcoes(valor) {
        return valor ? 'fa-check-square-o' : 'fa-square-o';
      },
      fusp() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
      },
    },
    computed: {
      tipoTodasSolicitacoesFUSP() {
        //return false;

        if (!this.fusp())
          return false;

        if (this.solicitacao.tipoBolsa !== 4) {
          return true;
        }
      },
      periodoDeVigencia() {
        let dataInicio = this.solicitacao.projeto.dataInicioVigencia;
        let dataTermino = this.solicitacao.projeto.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }

        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }

        return periodo;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.liberacaoCoordenador) || '---';
      },
      textoPertenceQuadro() {
        if (this.fusp())
            return 'Pertence ao quadro de funcionários da USP?'

        return 'Pertence ao quadro? Qual?';
      },
      tipoRPAAdicionalFUSP() {
          if (!this.fusp())
              return false;

          if (this.solicitacao.tipoBolsa === 2) {
              return true;
          } else if (this.solicitacao.tipoBolsa === 5) {
              return true;
          } else {
              return false;
          }
      },
      habilitarOuDesabilitarTermo() {
        if (!this.tipoTodasSolicitacoesFUSP)
            return false;

        return this.solicitacao.funcionarioPublico == 0 && this.fusp();
      },
      solBolsaMsgConfirmacao() {
        if (this.solicitacao.tipoBolsa == 5)
          return this.configuracao.solBolsaMsgAdicionalVariavel;

        return this.configuracao.solBolsaMsgConfirmacao;
      },
      visualizarTipoQuadroRegime() {
        if (!this.tipoTodasSolicitacoesFUSP)
            return false;

        if ((this.solicitacao.tipoBolsa == 1) || (this.solicitacao.tipoBolsa == 3))
          return false;

        if (!this.solicitacao.pertenceQuadroUSP)
          return false;

        return true;
      },
      anexarCERT() {
        return (this.solicitacao.tipoBolsa == 2) && this.solicitacao.regimeTrabalhoUSP == 1;
      },
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de ' +  this.configuracao.nomeModuloSolContratos + ' - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';      

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-bolsa';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              
              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="Solicitação de configuracao.nomeModuloSolContratos>"</cabecalho>

                <h3 class="m-t-none m-b">Dados da solicitação</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Projeto</dt>
                    <dd>{{ solicitacao.projeto ? solicitacao.projeto.nomeProjeto : '' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Tipo de projeto</dt>
                    <dd>{{ solicitacao.projeto.tipoProjeto ? solicitacao.projeto.tipoProjeto.nome : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Período de vigência</dt>
                    <dd>{{ periodoDeVigencia }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Nr. processo</dt>
                    <dd>{{ solicitacao.projeto ? solicitacao.projeto.nrProcesso : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.idSolicitacaoBolsa || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Data da solicitação</dt>
                    <dd>{{ solicitacao.dataSolicitacao | formatarNumeroEmDataExtenso }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Coordenador do projeto</dt>
                    <dd>{{ solicitacao.projeto.coordenador ? solicitacao.projeto.coordenador.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Data de liberação do coordenador</dt>
                    <dd>{{ dataLiberacaoCoordenador }}</dd>
                  </dl>
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Liberado por</dt>
                    <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Nº protocolo</dt>
                    <dd>{{ solicitacao.protocolo ? solicitacao.protocolo.numeroProtocolo : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Código de barras protocolo</dt>
                    <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.exibirRubricaSubrubricaSolicitacaoWeb || solicitacao.projeto.utilizarRubricaSubrubricaWeb">
                  <dl class="col-xs-6">
                    <dt>Rubrica</dt>
                    <dd>{{ solicitacao.rubrica ? solicitacao.rubrica.nome : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>Subrubrica</dt>
                    <dd>{{ solicitacao.subrubrica ? solicitacao.subrubrica.nome : '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Dados cadastrais</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Tipo de bolsa</dt>
                    <dd>{{ tipoBolsa(solicitacao.tipoBolsa) }}</dd>
                  </dl>
                </div>

                <div class="row">
                    <dl class="col-xs-4">
                        <dt>Nome</dt>
                        <dd>{{ solicitacao.nome || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-4">
                        <dt>Nome social</dt>
                        <dd>{{ solicitacao.nomeSocial || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-4">
                        <dt>CPF</dt>
                        <dd>{{ solicitacao.cpfCnpj || '---' }}</dd>
                    </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Data de nascimento</dt>
                    <dd>{{ solicitacao.dataNascimento || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Identidade</dt>
                    <dd>{{ solicitacao.identidade || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>INSS</dt>
                    <dd>{{ solicitacao.inss || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>PISPASEP</dt>
                    <dd>{{ solicitacao.pisPasep || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Endereço</dt>
                    <dd>{{ solicitacao.endereco || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.numero || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Complemento</dt>
                    <dd>{{ solicitacao.complemento || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Bairro</dt>
                    <dd>{{ solicitacao.bairro || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Cidade</dt>
                    <dd>{{ solicitacao.cidade || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Estado</dt>
                    <dd>{{ solicitacao.uf || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Cidade</dt>
                    <dd>{{ solicitacao.cidade || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-2">
                    <dt>Telefone 1</dt>
                    <dd>{{ solicitacao.telefone1 || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Telefone 2</dt>
                    <dd>{{ solicitacao.telefone2 || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2" v-if="tipoTodasSolicitacoesFUSP">
                      <dt>Funcionário público</dt>
                      <dd>{{typeof  solicitacao.funcionarioPublico === "string" ? solicitacao.funcionarioPublico === 'true' ? 'Sim' : 'Não' : solicitacao.funcionarioPublico == true ? 'Sim' : 'Não'}}</dd>
                  </dl>

                  <dl class="col-xs-2" v-if="solicitacao.funcionarioPublico && tipoTodasSolicitacoesFUSP">
                      <dt>{{ textoPertenceQuadro }}</dt>
                      <dd>{{typeof  solicitacao.pertenceQuadroUSP === "string" ? solicitacao.pertenceQuadroUSP === 'true' ? 'Sim' : 'Não' : solicitacao.pertenceQuadroUSP == true ? 'Sim' : 'Não'}}</dd>
                  </dl>

                  <dl class="col-xs-3" v-if="!tipoTodasSolicitacoesFUSP">
                    <dt>{{ textoPertenceQuadro }}</dt>
                    <dd v-if="!tipoRPAAdicionalFUSP">{{ solicitacao.pertenceQuadro ? 'Sim - ' : 'Não' }} {{ solicitacao.pertenceQuadro ? tipoQuadro(solicitacao.tipoQuadro).nome : '' }}</dd>
                  </dl>

                  <dl class="col-xs-2" v-if="!tipoTodasSolicitacoesFUSP">
                    <dt>Matrícula</dt>
                    <dd>{{ solicitacao.matricula || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3" v-if="!tipoTodasSolicitacoesFUSP">
                    <dt>SIAPE</dt>
                    <dd>{{ solicitacao.siafi || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2" v-if="visualizarTipoQuadroRegime">
                    <dt>Tipo quadro</dt>
                    <dd>{{ tipoQuadroUSP(solicitacao.tipoQuadroUSP) ? tipoQuadroUSP(solicitacao.tipoQuadroUSP).nome : '---' || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2" v-if="visualizarTipoQuadroRegime">
                    <dt>Regime de trabalho USP</dt>
                    <dd>{{ solicitacao.tipoQuadroUSP ? regimeTrabalhoUSP(solicitacao.regimeTrabalhoUSP) ? regimeTrabalhoUSP(solicitacao.regimeTrabalhoUSP).nome : '---' : '---' }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="tipoTodasSolicitacoesFUSP && solicitacao.funcionarioPublico && solicitacao.pertenceQuadroUSP != null">
                    <dl class="col-xs-2">
                        <dt>Cargo</dt>
                        <dd>{{ solicitacao.cargo || '---' }}</dd>
                    </dl>
                    <dl class="col-xs-4" v-if="solicitacao.pertenceQuadroUSP">
                        <dt>Departamento</dt>
                        <dd>{{ solicitacao.departamento || '---' }}</dd>
                    </dl>
                    <dl class="col-xs-4" v-if="solicitacao.pertenceQuadroUSP">
                        <dt>Unidade</dt>
                        <dd>{{ solicitacao.unidade || '---' }}</dd>
                    </dl>
                    <dl class="col-xs-2" v-if="!solicitacao.pertenceQuadroUSP">
                        <dt>CNPJ instituição pública</dt>
                        <dd>{{ solicitacao.cnpjInstituicaoPublica || '---' }}</dd>
                    </dl>
                    <dl class="col-xs-4" v-if="!solicitacao.pertenceQuadroUSP">
                        <dt>Instituição pública</dt>
                        <dd>{{ solicitacao.instituicaoPublica || '---' }}</dd>
                    </dl>
                    <dl class="col-xs-2" v-if="!solicitacao.pertenceQuadroUSP">
                        <dt>Carga horária mensal na Instituição</dt>
                        <dd>{{ solicitacao.cargaHorariaInstituicao || '---' }}</dd>
                    </dl>
                    <dl class="col-xs-2">
                        <dt>Matrícula</dt>
                        <dd>{{ solicitacao.matricula || '---' }}</dd>
                    </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>E-mail do beneficiário</dt>
                    <dd>{{ solicitacao.email || '---' }}</dd>
                  </dl>
                </div>

                <div v-if="solicitacao.tipoBolsa != 4">
                  <h3 class="m-t-none m-b">Dados da bolsa</h3>

                  <div class="hr-line-dashed margin-top-5"></div>

                  <div class="row">
                    <dl :class="{'col-xs-6': this.solicitacao.tipoBolsa === 1,'col-xs-4': this.solicitacao.tipoBolsa === 2, 'col-xs-2': this.solicitacao.tipoBolsa !== 2}">
                      <dt>Valor (R$)</dt>
                      <dd>{{ solicitacao.valorContrato || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2" v-if="this.solicitacao.tipoBolsa !== 2">
                      <dt>Carga horária</dt>
                      <dd>{{ solicitacao.cargaHoraria || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2" v-if="this.solicitacao.tipoBolsa === 1">
                      <dt>Curso</dt>
                      <dd>{{ solicitacao.cursoDoContratado || '---' }}</dd>
                    </dl>

                    <dl :class="{'col-xs-3': this.solicitacao.tipoBolsa === 1, 'col-xs-4': this.solicitacao.tipoBolsa !== 1}">
                      <dt>Data vigência início</dt>
                      <dd>{{ solicitacao.dataVigenciaInicio || '---' }}</dd>
                    </dl>

                    <dl :class="{'col-xs-3': this.solicitacao.tipoBolsa === 1, 'col-xs-4': this.solicitacao.tipoBolsa !== 1}">
                      <dt>Data vigência fim</dt>
                      <dd>{{ solicitacao.dataVigenciaFim || '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-xs-12">
                      <dt>Objetivo</dt>
                      <dd class="white-space-pre">{{ solicitacao.objetivo || '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-xs-12">
                      <dt>Observação</dt>
                      <dd class="white-space-pre">{{ solicitacao.observacao || '---' }}</dd>
                    </dl>
                  </div>
                </div>

                <div v-if="solicitacao.tipoBolsa == 4">
                  <h3 class="m-t-none m-b">Dados do termo aditivo</h3>

                  <div class="hr-line-dashed margin-top-5"></div>

                  <div class="row">
                    <dl class="col-xs-2">
                      <dt>Data termo aditivo</dt>
                      <dd>{{ solicitacao.dataTermoAditivoTa || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Vigência início</dt>
                      <dd>{{ solicitacao.dataVigenciaInicioTa || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Vigência término</dt>
                      <dd>{{ solicitacao.dataVigenciaTerminoTa || '---' }}</dd>
                    </dl>

                    <dl class="col-sm-3">
                      <dt>
                        <i class="fa" :class="classeOpcoes(solicitacao.tipoPlanoTrabalho)"></i> Alteração do plano de trabalho <br>
                      </dt>
                    </dl>

                    <dl class="col-sm-3">
                      <dt>
                        <i class="fa" :class="classeOpcoes(solicitacao.tipoTermoContratual)"></i> Alteração de termo contratual <br>
                      </dt>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-sm-4">
                      <dt>
                        <i class="fa" :class="classeOpcoes(this.solicitacao.tipoValor == 1 || this.solicitacao.tipoValor == 2)"></i> Valor <br>
                      </dt>
                    </dl>

                    <dl class="col-sm-4">
                      <dt>
                        <i class="fa" :class="classeOpcoes(this.solicitacao.tipoPrazo == 1 || this.solicitacao.tipoPrazo == 2)"></i> Prazo <br>
                      </dt>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-sm-2">
                      <dd>
                        {{ this.solicitacao.tipoValor == 1 ? 'Acréscimo' : this.solicitacao.tipoValor == 2 ? 'Descréscimo' : '---' }}
                      </dd>
                    </dl>

                    <dl class="col-sm-2">
                      <dd>
                        {{ this.solicitacao.valortermo | formatarNumero }}
                      </dd>
                    </dl>

                    <dl class="col-sm-2">
                      <dd>
                        {{ this.solicitacao.tipoPrazo == 1 ? 'Acréscimo' : this.solicitacao.tipoPrazo == 2 ? 'Descréscimo' : '---' }}
                      </dd>
                    </dl>

                    <dl class="col-sm-2">
                      <dd>
                        {{ this.solicitacao.dias || '---' }} dia(s)
                      </dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-xs-12">
                      <dt>Descrição do objeto</dt>
                      <dd class="white-space-pre">{{ solicitacao.descricaoObjetoTa || '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-xs-12">
                      <dt>Observação</dt>
                      <dd class="white-space-pre">{{ solicitacao.observacaoTa || '---' }}</dd>
                    </dl>
                  </div>
                </div>

                <div>
                  <h3 class="m-t-none m-b">Dados bancários</h3>

                  <div class="hr-line-dashed margin-top-5"></div>

                  <div class="row" v-if="solicitacao.tipoConta != 4">
                    <dl class="col-xs-3">
                      <dt>Banco</dt>
                      <dd>{{ solicitacao.banco || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Agência</dt>
                      <dd>{{ solicitacao.agencia || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Conta</dt>
                      <dd>{{ solicitacao.conta || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Tipo de conta</dt>
                      <dd>{{ tipoConta(solicitacao.tipoConta).nome }}</dd>
                    </dl>
                  </div>

                  <div class="row" v-if="solicitacao.tipoConta == 4">
                    <dl class="col-xs-3">
                      <dt>Tipo pix</dt>
                      <dd>{{ tipoPix(solicitacao.tipoPix).nome }}</dd>
                    </dl>

                    <dl class="col-xs-9">
                      <dt>Chave PIX</dt>
                      <dd>{{ solicitacao.chavePix || '---' }}</dd>
                    </dl>
                  </div>
                </div>
                
                <div v-if="habilitarOuDesabilitarTermo && solicitacao.pessoaAssinaturaTermo">
                  <h3 class="m-t-none m-b">Termo de consentimento</h3>
                  <div class="hr-line-dashed margin-top-5"></div>
                  <div class="row">
                    <div class="col-xs-12">
                        <div style="font-size: 18px;">
                            <span style="text-decoration: underline;"><strong>INFORMAÇÃO RELEVANTE</strong></span><br /><br />
                            Anualmente, como parte dos
                            procedimentos de fiscalização, a Fundação deve apresentar ao Tribunal de Contas
                            do Estado de São Paulo – TCE/SP, uma relação com todos os pagamentos realizados
                            a beneficiários pessoas físicas, nas modalidades: autônomo, adicional de
                            inovação e bolsistas. O objetivo do órgão é realizar o cruzamento dessas
                            informações com a base de dados do governo. Ao informar que o(a) beneficiário(a)
                            não é um <span style="text-decoration: underline;">funcionário público</span>, <span style="text-decoration: underline;">estou ciente</span> que a inexatidão dessa
                            informação, poderá acarretar notificações à Fundação e a coordenação do
                            projeto, solicitando esclarecimentos sobre a divergência dos dados fornecidos.
                            <br /><br />
                        </div>
                    </div>
                  </div>

                  <div class="row">
                      <dl class="col-xs-4">
                          <dt>Nome</dt>
                          <dd>{{ solicitacao.pessoaAssinaturaTermo || '---' }}</dd>
                      </dl>
                      <dl class="col-xs-4">
                          <dt>Documento</dt>
                          <dd>{{ solicitacao.cpfAssinaturaTermo || '---' }}</dd>
                      </dl>
                      <dl class="col-xs-4">
                          <dt>Data aceite</dt>
                          <dd>{{solicitacao.dataAssinaturaTermo | formatarData }} às {{solicitacao.dataAssinaturaTermo | formatarHora }}</dd>
                      </dl>
                  </div>
                </div>

                <div v-if="anexarCERT">
                  <h3 class="m-t-none m-b">Arquivos anexados:</h3>
                  <div class="hr-line-dashed margin-top-5"></div>
                  <div class="row" v-if="configuracao.solicitacaoPJAnexarNF">
                    <dl class="col-xs-2">
                      <dt>Anexou a CERT</dt>
                      <dd>{{ solicitacao.solicitacaoAnexouArquivo == null ? '---' : solicitacao.solicitacaoAnexouArquivo == 'true' ? 'Sim' : 'Não' }}</dd>
                    </dl>
                    <dl class="col-xs-10" v-if="solicitacao.solicitacaoAnexouArquivo == 'false'">
                      <dt>Informe o motivo pelo qual o documento não foi anexado</dt>
                      <dd>{{ solicitacao.solicitacaoJustificativaAnexo }}</dd>
                    </dl>
                  </div>
                </div>

                <div class="hr-line-dashed margin-top-5" v-if="solBolsaMsgConfirmacao"></div>

                <div class="row" v-if="solBolsaMsgConfirmacao">
                  <div class="col-md-12">
                    <p><i>{{solBolsaMsgConfirmacao}}</i></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa/componentes/SolicitacaoBolsaRelatorio.vue